import { Pipe, PipeTransform, Sanitizer, SecurityContext } from '@angular/core';

/**
 * Se quiser mostrar substring com outro estilo (ex, vermelho), selecionar <b> com css
 * importante: usar em [innerHTML]
 * @example emento-inteiro. {
 *  b {
 *      seu css customizado
 *  }
 * }
 */
@Pipe({
    name: 'boldSubstring'
})
export class BoldSpanPipe implements PipeTransform {

  transform(textVal: string, subTextValue: string): string {
    if (subTextValue.length == 0) {
        return textVal
    }

    return textVal.replace(subTextValue , '<b>' + subTextValue  + '</b>');
}
}